// extracted by mini-css-extract-plugin
module.exports = {"race_setting_wrapper":"RaceSetting_race_setting_wrapper__3Zfn5"};